import "./SingleProductTemplate.module.css"
import MainNavigation from "@/reusable_sections/Header"
import SingleProductTemplateSection from "./sections/SingleProductTemplateSection"
import SariHutFooter from "@/reusable_sections/Footer"

export default function SingleProductTemplatePage() {

  return (
    <div>
      <MainNavigation />
      <SingleProductTemplateSection />
      <SariHutFooter />
    </div>
  )
}
